import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import StaticInput from '../elements/forms/StaticInput'
import DateInput from '../elements/forms/DateInput'
import Dismissible from '../elements/Dismissible'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_DATE: 'La date ne peut pas être vide.',
  EMPTY_NAME: 'Le titre ne peut pas être vide.'
}

class ExecutionForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputDate = this.onChangeInputDate.bind(this)
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputPeople = this.onChangeInputPeople.bind(this)
    this.onChangeInputRemark = this.onChangeInputRemark.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      date: (props.data && props.data.date) || null,
      name: (props.data && props.data.name) || '',
      people: (props.data && props.data.people) || '',
      remark: (props.data && props.data.remark) || ''
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputDate(date) {
    this.setInput({ date })
  }

  onChangeInputName(name) {
    this.setInput({ name })
  }

  onChangeInputPeople(people) {
    this.setInput({ people })
  }

  onChangeInputRemark(remark) {
    this.setInput({ remark })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!this.props.data && _.isNull(this.state.input.date)) {
      formErrors.push(ERROR.EMPTY_DATE)
    }
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      _.pick(this.state.input, 'name', 'people', 'remark'),
      this.props.data
        ? {}
        : {
            date: this.state.input.date
          },
      this.props.maintenance
        ? {
            maintenance: _.pick(this.props.maintenance, 'id')
          }
        : {}
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error)}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          {
            !this.props.data && this.props.maintenance
              ? <StaticInput
                  label='Matériel'
                  content={this.props.maintenance.product.name}
                />
              : null
          }
          {
            !this.props.data && this.props.maintenance
              ? <StaticInput
                  label='Maintenance'
                  content={this.props.maintenance.name}
                />
              : null
          }
          {
            this.props.data
              ? <StaticInput
                  label='Date'
                  content={AppUtils.displayDate(this.props.data.date)}
                />
              : <DateInput
                  label='Date'
                  value={this.state.input.date}
                  onChange={this.onChangeInputDate}
                  allowBlurEmpty={false}
                />
          }
          <TextInput
            label='Titre'
            placeholder='Mise en eau VPI'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          {
            this.props.data
              ? <StaticInput
                  label='Saisi par'
                  content={this.props.data.user.name}
                />
              : null
          }
          <TextInput
            label='Participants'
            placeholder='Jean et Pierre'
            value={this.state.input.people}
            onChange={this.onChangeInputPeople}
          />
          <TextInput
            label='Remarque'
            placeholder='...'
            value={this.state.input.remark}
            onChange={this.onChangeInputRemark}
            multiline={true}
          />
        </Form>
      </React.Fragment>
    )
  }
}

ExecutionForm.propTypes = {
  data: PropTypes.object,
  maintenance: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object
}

export default ExecutionForm



// WEBPACK FOOTER //
// ./src/components/forms/ExecutionForm.js